export enum WithdrawalStatus {
    Pending = 'pending',
    Validated = 'validated',
    ReconciliationFailed = 'reconciliation_failed',
    Completed = 'completed',
}

export type PointsDonation = {
    txnId: number;
    receiptNumber: number;
    donorId: number;
    donorName: string;
    amount: number;
    fees: number;
    netAmount: number;
    datetime: string;
    envelopeId: number;
};

export type WithdrawalDonation = {
    id: number;
    userId: number;
    userType: string;
    requestedByUserId: number;
    requestedByUserType: string;
    amount: number;
    amountConverted: number;
    status: WithdrawalStatus;
    donation: PointsDonation;
    createdAt: string;
    updatedAt: string;
};
